import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface EligibilityErrorCardProps {
  message: string;
}

export const EligibilityErrorCard = ({ message }: EligibilityErrorCardProps) => {
  const { t } = useTranslation("forms");

  return (
    <div className="border border-red-500 rounded-md p-4 flex gap-3 items-start">
      <AlertTriangle className="h-5 w-5 text-red-500 flex-shrink-0" />
      <div>
        <p className="font-semibold text-sm">{t("Unable to Check Eligibility")}</p>
        <p className="text-muted-foreground text-xs mt-1">{message}</p>
      </div>
    </div>
  );
};
